// Who takes the Team Lead Certification. Amanda Bolduc has no Leads section, so she is excluded.
export const CERT_EXCLUDED_EMAILS = ['amanda.bolduc@exprealty.com'];
const low = (s) => String(s || '').trim().toLowerCase();
export const isCertExcluded = (user = {}, authEmail = '') => {
  const p = user.profile || {};
  return [authEmail, user.email, user.contactEmail, p.email, p.contactEmail].some((e) => CERT_EXCLUDED_EMAILS.includes(low(e)));
};
